import { createSelector } from '@ngrx/store';
import { latestTransactionsState } from '../root';

export const getLatestTransactionsForMember = (memberId: number) =>
    createSelector(latestTransactionsState, (latestTransactions) => latestTransactions.find((obj) => obj.memberId === memberId) || null);
